<template>
  <h1 data-slot="default">
    <slot>H1</slot>
  </h1>
</template>

<script>

export default {
  name: "m-h1",
};
</script>

<style scoped>
</style>